import legacyAppContent from './appContent';
import type {AppContent} from './appContent.types';
import {getContent} from './content';

const getTypedContent = (): AppContent => getContent() as AppContent;

const getLoginContent = () => getTypedContent().loginContent || {};
const getCountryContentList = () => getTypedContent().countryContentList || [];
const getAutoDeliveryContent = () => getTypedContent().autoDeliveryContent;
const getOtpContent = () => getTypedContent().otpContent || {};
const getAgeGateContent = () => getTypedContent().ageGateContent;
const getAgeGatePopupContent = () => getAgeGateContent()?.ageGatePopupContent;
const getAgeGateDeniedContent = () => getAgeGateContent()?.ageGateDeniedContent;
const getAgeGateLockedContent = () => getAgeGateContent()?.ageGateLockedContent;

const appContent = {
    ...legacyAppContent,
    getLoginContent,
    getCountryContentList,
    getAutoDeliveryContent,
    getOtpContent,
    getAgeGateContent,
    getAgeGatePopupContent,
    getAgeGateDeniedContent,
    getAgeGateLockedContent,
};

export default appContent;
export {
    getAgeGateContent,
    getAgeGateDeniedContent,
    getAgeGateLockedContent,
    getAgeGatePopupContent,
    getAutoDeliveryContent,
    getCountryContentList,
    getLoginContent,
    getOtpContent,
};
